import FilterListIcon from "@mui/icons-material/FilterList";
import { FormControlLabel, RadioGroup } from "@mui/material";
import React, { useState } from "react";

import { OutlinedButton } from "@/Components/v2/atoms/Button";
import { FormControl } from "@/Components/v2/atoms/FormControl";
import { Menu } from "@/Components/v2/atoms/Menu";
import { Radio } from "@/Components/v2/atoms/Radio";
import { Stack } from "@/Components/v2/atoms/Stack";
import { GeoViewToggle } from "@/shared/types";

interface FilterButtonContainerProps {
  geoViewLabels?: Record<GeoViewToggle, string> | undefined;
  geoView: GeoViewToggle;
  setGeoView: (view: GeoViewToggle) => void;
}

const FilterButtonContainer: React.FC<FilterButtonContainerProps> = ({
  geoViewLabels,
  geoView,
  setGeoView,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGeoView(event.target.value as GeoViewToggle);
  };

  return (
    <div>
      <OutlinedButton
        aria-controls={open ? "simple-menu" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        variant="outlined"
        startIcon={<FilterListIcon />}
      >
        Filter
      </OutlinedButton>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
        <Stack padding={2}>
          {geoViewLabels && (
            <FormControl component="fieldset">
              <RadioGroup
                aria-labelledby="radio-group-label"
                aria-label="choice"
                name="radio-buttons-group"
                value={geoView}
                onChange={handleRadioChange}
                sx={{ borderBottom: "1px solid #e0e0e0" }}
              >
                {Object.entries(geoViewLabels).map(([value, label]) => (
                  <FormControlLabel key={value} value={value} control={<Radio />} label={label} />
                ))}
              </RadioGroup>
            </FormControl>
          )}
        </Stack>
      </Menu>
    </div>
  );
};

export default FilterButtonContainer;
